<section class="auto-ship-products">
  <nav class="auto-ship-navigation" [attr.aria-label]="'autoShip.schedule.navigationLabel' | cxTranslate">
    <span class="auto-ship-navigation__item" aria-current="page">
      {{ 'autoShip.products.partsSelectionTab' | cxTranslate }}
    </span>

    <span class="auto-ship-navigation__item auto-ship-navigation__item--active">
      {{ 'autoShip.schedule.shipmentScheduleTab' | cxTranslate }}
    </span>
  </nav>

  <h1 class="title">{{ 'autoShip.schedule.title' | cxTranslate }}</h1>

  <cx-spinner *ngIf="loading" class="page-spinner"></cx-spinner>

  <div class="auto-ship-layout" *ngIf="!loading">
    <div class="results">
      
      <gen-auto-ship-shipment-frequency
        (numberOfShipmentsChange)="onNumberOfShipmentsChange($event)"
      ></gen-auto-ship-shipment-frequency>

      <gen-auto-ship-shipment-date
        [numberOfShipments]="numberOfShipments"
        (shipmentDatesChange)="onShipmentDatesChange($event)" 
      ></gen-auto-ship-shipment-date>
          
      <div class="shipment-actions">
        
        <button 
          class="cx-btn btn btn-block btn-secondary auto-ship-back-to-product"
          [routerLink]="PREVIOUS_STEP_URL"
          [disabled]="loading"
        >
          {{ 'autoShip.schedule.backToProduct' | cxTranslate }}
        </button>

        <button 
          *ngIf="numberOfShipments > 0"
          type="button" 
          class="btn btn-primary auto-ship-shipment-schedule"
          [disabled]="shipmentDatesInvalid"
          (click)="scheduleShipment()"
        >
          {{ 'autoShip.schedule.shipmentSchedule' | cxTranslate }}
        </button>

      </div>
    </div>
  </div>
</section>